import { render } from "./AddToPriceListModal.vue?vue&type=template&id=526f2ec5&scoped=true"
import script from "./AddToPriceListModal.vue?vue&type=script&lang=js"
export * from "./AddToPriceListModal.vue?vue&type=script&lang=js"

import "./AddToPriceListModal.vue?vue&type=style&index=0&id=526f2ec5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-526f2ec5"]])

export default __exports__